import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useHasSceneCastRelationship } from '../../scene/hooks/useHasSceneCastRelationship';
import GridSkeletons from '../../../components/skeletons/GridSkeletons';
import HorizontalScroll from '../../my-page/components/HorizontalScroll';
import LinkCardItem from './LinkCardItem';
import FeatureGate from '../../../domains/features/ui/components/FeatureGate';
import { ROUTES } from '../../../constants/routes';
import { FEATURE_KEYS } from '../../../domains/features/constants';

interface MainBannerSectionProps {
  isBannerSkeletonVisible: boolean;
}

const MainBannerSection = ({ isBannerSkeletonVisible }: MainBannerSectionProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const hasSceneCastRelationship = useHasSceneCastRelationship();

  return (
    <>
      {isBannerSkeletonVisible ? (
        <HorizontalScroll>
          <div className="px-[20px] pb-[10px] pt-[11px]">
            <GridSkeletons
              gridSize={3}
              skeletonSize={3}
              skeletonHeight="134px"
              skeletonWidth="248px"
              showText={false}
            />
          </div>
        </HorizontalScroll>
      ) : (
        <HorizontalScroll>
          <div className="flex flex-row gap-[8px] px-[20px] pt-[8px]">
            <FeatureGate featureKey={FEATURE_KEYS.SCENE_BETA_USER}>
              <button
                type="button"
                className="relative flex flex-col items-start justify-end overflow-hidden text-pure-white bg-[linear-gradient(121deg,#93FFB9_0.62%,#7A45FF_77.28%)] leading-tight gap-[7px] w-[248px] h-[134px] pb-[23px] pl-[22px] rounded-[18px] shadow-[0_0_18.949px_0_rgba(255,255,255,0.55)_inset]"
                onClick={() =>
                  hasSceneCastRelationship
                    ? navigate(ROUTES.SCENE.MAIN)
                    : navigate(ROUTES.SCENE.INTRO)
                }
              >
                <img
                  src="/assets/card_banner/scene_banner_image.png"
                  alt="scene banner"
                  className="object-cover absolute right-0 bottom-[0px] w-[125px] h-[134px]"
                />
                <p className="text-[12px] font-semibold">{t('ChatPage.scene.title')}</p>
                <div className="overflow-hidden w-full">
                  <p className="text-[17px] font-bold whitespace-pre-line text-left">
                    {t('ChatPage.scene.description')}
                  </p>
                </div>
              </button>

              <button
                type="button"
                className="relative flex flex-col items-start justify-end overflow-hidden text-pure-white bg-[linear-gradient(180deg,#DF93FF_0%,#9D76FF_100%)] leading-tight gap-[7px] w-[248px] h-[134px] pb-[23px] pl-[22px] rounded-[18px] shadow-[0_0_18.949px_0_rgba(255,255,255,0.55)_inset]"
                onClick={() => navigate('/landing')}
              >
                <img
                  src="/assets/card_banner/landing_banner_image.png"
                  alt="profile card banner"
                  className="object-cover absolute right-[-45px] bottom-[0px] w-[124px] h-[187px]"
                />
                <p className="text-[12px] font-semibold">{t('ChatPage.profileCard.title')}</p>
                <div className="overflow-hidden w-full">
                  <p className="text-[17px] font-bold whitespace-pre-line text-left">
                    {t('ChatPage.profileCard.description')}
                  </p>
                </div>
              </button>
            </FeatureGate>

            <LinkCardItem
              title="ChatPage.promotion.title"
              description="ChatPage.promotion.description"
              navigateTo="/lounge"
              className="bg-[linear-gradient(180deg,#A2CCF9_0%,_#769BFF_100%)] text-white"
              rightContent={
                <div className="w-[63px] h-[58px] absolute right-[14px] top-[15px]">
                  <img
                    src="/assets/card_banner/promotion_banner_image.png"
                    alt="promotion banner"
                    className="mix-blend-overlay text-[#97BFFB]"
                  />
                </div>
              }
            />
          </div>
        </HorizontalScroll>
      )}
    </>
  );
};

export default MainBannerSection;
